// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__o1ckh","unfoldIn":"Modal_unfoldIn__jrTqW"};